import src from "IMAGE";
export default { src, width: 658, height: 222, blurWidth: 0, blurHeight: 0};
